import {useEffect, useState} from "react";
import UserSectionMenu from "../../components/UserSectionMenu";
import Pagination from "../../components/Pagination";
import UserInformation from "../../components/UserInformation";
import AddApplicantForm from "./AddApplicantForm";
import AddUserBox from "../../components/AddUserBox";
import {MyContext} from "../../context/myContext";
import {PersianToEnglish} from "numeral-convert";
import HistoryPopUp from "../../components/HistoryPopUp";
import {
    getExcel,
    getNomadHistory,
    selectNomadHistoryArray,
    selectShowForm
} from "../common-states/commonStatesSlice";
import {useDispatch, useSelector} from "react-redux";
import {getNomads, setNomadInfo, selectApplicantBodyArray, selectSelectedNomad, setInputs, setSelects}
    from "./applicantSlice";
import {showPopUp, callApiAgain, selectShowHistory, selectShowEditForm, selectCallApi} from "../common-states/commonStatesSlice";
import {handleShowPopUp} from "../common-states/handleShowPopUp";

const ApplicantManagement = () => {
    const allNomadsTableHead = ["حذف", "ویرایش", "سوابق", "تعداد دام", "تعداد خانوار", "منطقه عشایری", "شهر", "شماره تماس", "کد ملی", "نام و نام خانوادگی", "ردیف",];
    const nomadHistoryTableHead = ['هزینه', 'حجم آب', 'زمان تحویل', 'تاریخ تحویل', 'راننده', 'زمان درخواست', 'منطقه', 'کد پیگیری', 'نوع آب', 'ردیف',]
    const [nomad, setNomad] = useState({id: null, name: ''})
    const storeDispatch = useDispatch()
    const dispatch = useDispatch()
    const bodyArray = useSelector(selectApplicantBodyArray)
    const callApi = useSelector(selectCallApi)
    const showForm = useSelector(selectShowForm)
    const showEditForm = useSelector(selectShowEditForm)
    const showHistory = useSelector(selectShowHistory)
    const selectedNomad = useSelector(selectSelectedNomad)
    const historyArray = useSelector(selectNomadHistoryArray)
    const handleShowForm = (item) => {
        setNomad({...nomad, id: item.nomad_id}) // set id to send for put request in the form for editing nomad
        storeDispatch(showPopUp({type: 'showEditForm', value: !showEditForm}))
        if(showEditForm === false){
            let birthday = item.birthday !== '0621-03-21' ? PersianToEnglish(new Date(item.birthday).toLocaleDateString('fa-IR')) : '';
            let editInputs = {
                fatherName: item.father_name ?? '', name: item.name, birthday: birthday, code: item.national_code, phone: item.mobiles[1]?.mobile ?? '', mobile: item.mobiles[0].mobile, distance: item.dewatering_to_evacuation_distance ?? '',
                family: item.population, insuredLiveStock: item.insured_livestock_count ?? '', liveStock: item.livestock_count, nomadicArea: item.region, waterVolume: item.water_volume, membershipNumber: item.authentication_id
            }
            storeDispatch(setInputs(editInputs))
            let editSelects = {city: item?.city_id, province: item.province, tank: (item.water_storage_type === 0 ? 'تانکر' : item.water_storage_type === 1 ? 'آب انبار' : 'استخر'), registrationType: item.authentication_type === 0 ? 'عضویت در تعاونی' : 'مورد تایید رئیس'}
            storeDispatch(setSelects(editSelects))
        }
    }
    const handleShowHistory = (item) => {
        console.log(item)
        storeDispatch(showPopUp({type: 'showHistory', value: !showHistory}))
        setNomad({...nomad, name: item.name}) //set name to send for historyPopup as title
        if(showHistory === false){
            storeDispatch(getNomadHistory(item.nomad_id))
        }
    }
    const handleClosePopup = () => {
        handleShowPopUp(dispatch, showForm, showEditForm, showHistory)
        storeDispatch(setNomadInfo({obj: null, type: ''}))
    }

    const handleGetExcel = (cityId) => {
        let items = [{item:"row",col_name:"ردیف"},{item:"name",col_name:"نام"},{item:"father_name",col_name:"نام پدر"},{item:"national_code",col_name:"کد ملی"},{item:"city_id",col_name:"شهر"},{item:"region",col_name:"منطقه عشایری"},{item:"water_storage_type",col_name:"نوع مخزن"},{item:"livestock_count",col_name:"تعدا دام"},{item:"population",col_name:"تعداد خانوار"}]
        const data = {
            city_id: cityId === '' ? null : cityId,
            sheet_type: 1,
            items: items
        }
        dispatch(getExcel(data))
    }

    const handleChangePage = (item) => {
        storeDispatch(getNomads({searchParam: '', pageNum: item, dispatch}))
    }

    const handleSearch = (searchParam) => {
        dispatch(getNomads({searchParam, pageNum: 1, dispatch}))
    }

    useEffect(() => {
        storeDispatch(getNomads({searchParam: '', pageNum: 1, dispatch}))
        storeDispatch(callApiAgain(false))
        // eslint-disable-next-line
    }, [callApi]);

    useEffect(() => {
        if(selectedNomad?.obj !== null){
            if(selectedNomad?.type === 'showEditForm'){
                handleShowForm(selectedNomad?.obj)
            }
            else if(selectedNomad?.type === 'showHistory'){
                handleShowHistory(selectedNomad?.obj)
            }
            storeDispatch(setNomadInfo({obj: null, type: ''}))
        }
        // eslint-disable-next-line
    }, [selectedNomad])

    return (
        <div className="applicant-box">
            <div className={`${(showEditForm || showHistory || showForm) && 'show-dark-background'} dark-background`} onClick={handleClosePopup}></div>
            <MyContext.Provider value={{handleShowHistory, headArray: nomadHistoryTableHead, bodyArray: historyArray, title: `سوابق درخواست های ${nomad?.name}`}}>
                <HistoryPopUp />
            </MyContext.Provider>
            <MyContext.Provider value={{formTitle: 'ویرایش متقاضی', showEditForm, handleShowForm, registerBtn: 'ویرایش', nomadId: nomad?.id}}>
                <AddUserBox formComponent={AddApplicantForm}/> {/*This is for editNomadPopup*/}
            </MyContext.Provider>
            <UserSectionMenu
                buttonText="افزودن متقاضی"
                formTitle="افزودن متقاضی جدید"
                formComponent={AddApplicantForm}
                getSearchedInfo={handleSearch}
                handleGetExcel={handleGetExcel}
            />
            <MyContext.Provider value={{headArray: allNomadsTableHead, bodyArray, title: "مشخصات مشترکین ثبت شده"}}>
                <UserInformation />
            </MyContext.Provider>
            <Pagination handleChangePage={handleChangePage} callApi={callApi} />
        </div>
    );
};

export default ApplicantManagement;
